import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  selectIsPackageSearcherEnabled,
  selectIsFlightSearcherEnabled,
  selectIsHotelSearcherEnabled,
  selectFirstActiveRoute,
} from 'legacyfrontend/redux/selectors/application-selectors';
import { ROUTE_KEYS } from 'legacyfrontend/constants';

const { BUSCAR_X_PAQUETES, BUSCAR_X_VUELOS, BUSCAR_X_HOTELES, PAQUETES, PAQUETE } = ROUTE_KEYS;

export const useSearcherValidation = () => {
  const history = useHistory();
  const location = useLocation();

  const isPackageSearcherEnabled = useSelector(selectIsPackageSearcherEnabled);
  const isFlightSearcherEnabled = useSelector(selectIsFlightSearcherEnabled);
  const isHotelSearcherEnabled = useSelector(selectIsHotelSearcherEnabled);
  const firstActiveRoute = useSelector(selectFirstActiveRoute);

  const isSearchRoute =
    location.pathname.includes(BUSCAR_X_PAQUETES) ||
    location.pathname.includes(BUSCAR_X_VUELOS) ||
    location.pathname.includes(BUSCAR_X_HOTELES);

  useEffect(() => {
    const currentPath = location.pathname;

    if (
      currentPath.includes(BUSCAR_X_PAQUETES) ||
      currentPath.includes(PAQUETES) ||
      currentPath.includes(PAQUETE)
    ) {
      if (!isPackageSearcherEnabled) {
        history.replace(firstActiveRoute);
        return;
      }
    }

    if (currentPath.includes(BUSCAR_X_VUELOS)) {
      if (!isFlightSearcherEnabled) {
        history.replace(firstActiveRoute);
        return;
      }
    }

    if (currentPath.includes(BUSCAR_X_HOTELES)) {
      if (!isHotelSearcherEnabled) {
        history.replace(firstActiveRoute);
        return;
      }
    }
  }, [
    location.pathname,
    isPackageSearcherEnabled,
    isFlightSearcherEnabled,
    isHotelSearcherEnabled,
    firstActiveRoute,
    history,
  ]);

  return {
    isPackageSearcherEnabled,
    isFlightSearcherEnabled,
    isHotelSearcherEnabled,
    isSearchRoute,
    firstActiveRoute,
  };
};

export default useSearcherValidation;
